import './styles.scss';

import { ListGroup, ListGroupItem } from 'react-bootstrap';

import { FilterOption } from '@/models/gen/graphql';
import { HTMLAttributes } from 'react';
import { getClasses } from '@/utils';

type QuestionsTabsProps = Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> & {
  tabs: FilterOption[];
  selectedRoleId: string;
  onSelect: (roleId: string) => void;
};

export const QuestionsTabs = ({ tabs, selectedRoleId, onSelect, className, ...props }: QuestionsTabsProps) => {
  return (
    <div {...props} className={getClasses('QuestionsTabs', className)}>
      <ListGroup horizontal>
        {tabs.map((tab) => (
          <ListGroupItem key={tab.id} action active={tab.id === selectedRoleId} onClick={() => onSelect(tab.id)}>
            {tab.displayName}
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
};
